const AboutSection = () => {
  const stats = [
    { value: '100%', label: 'Natural' },
    { value: '5+', label: 'Tipos de Vinho' },
    { value: '2', label: 'Tamanhos de Vinagre' },
  ];

  return (
    <section className="py-20 md:py-28" style={{ background: '#FCF1D7', fontFamily: "'Sora', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-16">
          {/* Image */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative rounded-2xl overflow-hidden" style={{ height: 480 }}>
              <img
                src="https://public.readdy.ai/ai/img_res/70dffc0075a4b7302f828e6dbfe6fde9.jpg"
                alt="Produtor da vinícola com uvas"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C0000]/30 to-transparent"></div>
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 rounded-2xl p-5 w-44" style={{ background: '#710005' }}>
              <p className="text-3xl font-bold text-[#FCF1D7]" style={{ fontFamily: "'Playfair Display', serif" }}>100+</p>
              <p className="text-[#FCF1D7]/80 text-xs mt-1">Anos de tradição na produção artesanal</p>
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block bg-[#878450]/15 text-[#710005] text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5 border border-[#878450]/30">
              Nossa História
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C0000] leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Tradição que se
              <br />
              transmite em cada gole
            </h2>
            <p className="text-[#710005]/70 text-sm md:text-base leading-relaxed mb-5">
              Nossa vinícola nasceu do amor pela terra e pelas uvas. Há mais de duas décadas, produzimos com técnicas artesanais que preservam o sabor genuíno de cada fruta.
            </p>
            <p className="text-[#710005]/70 text-sm md:text-base leading-relaxed mb-10">
              Cada garrafa que sai da nossa vinícola carrega o cuidado e dedicação de pessoas apaixonadas pelo que fazem. Do vinho encorpado ao suco puro, cada produto é uma expressão da nossa terra.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
              {stats.map((s) => (
                <div key={s.label} className="text-center bg-white rounded-xl p-4 border border-[#878450]/15">
                  <p className="text-2xl font-bold text-[#710005]" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                  <p className="text-xs text-[#2C0000]/60 mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
